import React, { useState, useEffect } from 'react';
import { getOr, get } from 'lodash/fp';
import { Grid } from '@material-ui/core';
import TableMapView from './TableMapView';
import { TableMapActions } from '../TableMapActions';
import { getActiveSectionId, keyById, mapPlacesToLayout } from '../../../../utils';
import { TableMapProps } from './types';

const TableMap = ({ sections, onDragStop, onCreatePlace }: TableMapProps) => {
    const defaultSection: string = getActiveSectionId(sections);
    const [activeSectionId, setActiveSectionId] = useState<string>(defaultSection);

    const keyedSections = keyById(sections);

    useEffect(() => {
        const { [activeSectionId]: selectedSection } = keyedSections;
        if(!selectedSection) {
            const id = getActiveSectionId(sections);
            setActiveSectionId(id);
        }
    }, [activeSectionId, sections, keyedSections]);

    const activeSection = get(activeSectionId, keyedSections);
    const places = getOr([], 'places', activeSection);
    const mappedPlaces = mapPlacesToLayout(places);

    const createPlace = onCreatePlace(mappedPlaces);

    return (
        <Grid container>
            <Grid item xs={12}>
                <TableMapActions
                    onCreatePlace={createPlace}
                    sections={keyedSections}
                    activeSectionId={activeSectionId}
                    setActiveSectionId={setActiveSectionId}
                />
            </Grid>
            <Grid item xs={12}>
                <TableMapView
                    onDragStop={onDragStop}
                    mappedPlaces={mappedPlaces}
                    sectionId={activeSectionId}
                />
            </Grid>
        </Grid>
    );
};

export default TableMap;
